import { SignDocumentTokenDtoGen } from "@/services/sign/v1/data-contracts";
import { IDocumentTokenCoordinates, DocumentTokenCoordinates } from "./document-token-coordinates.entity";

class DocumentTokenDtoBase implements SignDocumentTokenDtoGen {
  /** The position and dimensions of the tokens */
  coordinates: IDocumentTokenCoordinates;

  /** The token */
  token: string;

  /** Required before a user can sign */
  isRequired?: boolean;

  /** If checked, user can edit the field */
  isEditable?: boolean;

  /** A short sentence explaining what this token is for */
  title?: string;

  /** A short sentence explaining what this token is for */
  description?: string;

  /** The token value */
  value?: string;

  constructor(token?: Partial<SignDocumentTokenDtoGen>) {
    this.coordinates = new DocumentTokenCoordinates(token?.coordinates);
    this.token = token?.token ?? "";
    this.isRequired = token?.isRequired;
    this.isEditable = token?.isEditable;
    this.title = token?.title;
    this.description = token?.description;
    this.value = token?.value;
  }
}

type IDocumentTokenDto = DocumentTokenDtoBase;
const DocumentTokenDto = DocumentTokenDtoBase;

export { IDocumentTokenDto, DocumentTokenDto, DocumentTokenDtoBase };
